import listActions from 'src/modules/initiative/list/initiativeListActions';
import InitiativeService from 'src/modules/initiative/initiativeService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'INITIATIVE_DESTROY';

const initiativeDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: initiativeDestroyActions.DESTROY_STARTED,
      });

      await InitiativeService.destroyAll([id]);

      dispatch({
        type: initiativeDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.initiative.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/initiative');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: initiativeDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: initiativeDestroyActions.DESTROY_ALL_STARTED,
      });

      await InitiativeService.destroyAll(ids);

      dispatch({
        type: initiativeDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.initiative.destroyAll.success'),
      );

      getHistory().push('/initiative');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: initiativeDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default initiativeDestroyActions;
